module.exports = __webpack_public_path__ + "static/media/logo_transparent.e60da243.png";